import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import { Button, Icon } from 'antd';
import { Link } from 'react-router-dom';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { OptionsDialogView } from 'src/core/ui/options-dialog.view';
import { TextView } from 'src/core/ui/text.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { ClientTypeEditorController } from '../parts/clienttype-editor.controller';
import { ClientStatusEditorController } from '../parts/clientstatus-editor.controller';
import { ClientPriorityEditorController } from '../parts/clientpriority-editor.controller';

@observer
export class ClientListView extends React.Component<ClientListViewProps, any> {
	@observable
	showDialog = false;

	constructor(props: any) {
		super(props);
	}

	@autobind
	private createNew() {
		this.showDialog = true;
		return Promise.resolve(null);
	}

	@autobind
	private closeDialog(selectedValue?: string) {
		if (selectedValue) {
			this.props.onItemDoubleClicked(selectedValue as any);
		}

		this.showDialog = false;
	}

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				sortable: true,
				render: (text, record: ClientSummary) => <Link to={`/crm/clients/${record.id}`}>{text}</Link>,
			},
			{
				key: 'clientNumber',
				title: 'Client Number',
				dataIndex: 'clientNumber',
				sortable: true,
				filter: {
					field: 'clientNumber',
					type: 'string',
					render: (value, onChange) => (
						<TextView
							suffix={value != null ? (< Icon type="close" style={{ color: 'rgba(0,0,0,.25)' }} onClick={() => {
								onChange(null);
							}} />) : null}
							mode='edit'
							label={null}
							value={value}
							onChanged={onChange}
						/>

					)
				}
			},
			{
				key: 'type',
				title: 'Type',
				dataIndex: 'type',
				sortable: true,
				render: (text: any, record: any, index: number) => {
					return record.typeText;
				},
				filter: {
					field: 'type',
					type: 'foreignKey',
					render: (value, onChange) => (
						<ClientTypeEditorController
							label={null}
							mode='edit'
							value={value}
							onChanged={onChange}
						/>
					)
				}
			},
			{
				key: 'status',
				title: 'Status',
				dataIndex: 'status',
				sortable: true,
				render: (text: any, record: any, index: number) => {
					return record.statusText;
				},
				filter: {
					field: 'status',
					type: 'foreignKey',
					render: (value, onChange) => (
						<ClientStatusEditorController
							label={null}
							mode='edit'
							value={value}
							onChanged={onChange}
						/>
					)
				}
			},
			{
				key: 'priority',
				title: 'Priority',
				dataIndex: 'priority',
				sortable: true,
				render: (text: any, record: any, index: number) => {
					return record.priorityText;
				},
				filter: {
					field: 'priority',
					type: 'foreignKey',
					render: (value, onChange) => (
						<ClientPriorityEditorController
							label={null}
							mode='edit'
							value={value}
							onChanged={onChange}
						/>
					)
				}
			},
			{
				key: 'managedByUserName',
				title: 'Managed by',
				dataIndex: 'managedById',
				sortable: true,
				render: (text: any, record: any, index: number) => {
					return record.managedByUserName;
				},
				filter: {
					field: 'managedById',
					type: 'foreignKey',
					render: (value, onChange) => (
						<UserEditorController
							label={null}
							isRole={false}
							mode='edit'
							value={value}
							onChanged={(value: UserSummary) => { onChange(value ? value.id : null) }}
							setBusy={this.props.setBusy}
						/>
					)
				}
			}
		];

		return (
			<div className="window window-normal">
				<OptionsDialogView
					closeDialog={this.closeDialog}
					options={[
						{
							key: 'Person',
							text: 'Person',
							checked: true
						},
						{
							key: 'Company',
							text: 'Company'
						}
					]}
					showDialog={this.showDialog}
					title='Choose a type'
					subtitle='You can choose between a person type or a company type.'
				/>
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }}
						createNewItem={this.createNew}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/list/client-list.view.tsx